import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './EditProduct.css';

const EditProduct = () => {
    const { id } = useParams(); // URL से प्रोडक्ट ID निकालने के लिए
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        slug: '',
        sku: '',
        category_id: '',
        brand_id: '',
        short_description: '',
        description: '',
        price: '',
        compare_at_price: '',
        gst_percent: 0,
        stock: 0,
        weight: '',
        status: 'active'
    });

    const [primaryImage, setPrimaryImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);


    const token = localStorage.getItem('admin_token') || sessionStorage.getItem('adminToken');


    useEffect(() => {
        const fetchProductDetails = async () => {
            try {
                setLoading(true);
                const response = await fetch(`https://rbuymart.rbhardwaj.com/server/api/admin/get_product_by_id.php?id=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}` 
                    }
                });
                const data = await response.json();

                if (data.status === 'success') {
                    const prod = data.product;
                    setFormData({
                        name: prod.name || '',
                        slug: prod.slug || '',
                        sku: prod.sku || '',
                        category_id: prod.category_id || '',
                        brand_id: prod.brand_id || '',
                        short_description: prod.short_description || '',
                        description: prod.description || '',
                        price: prod.price || '',
                        compare_at_price: prod.compare_at_price || '',
                        gst_percent: prod.gst_percent || 0,
                        stock: prod.stock || 0,
                        weight: prod.weight || '',
                        status: prod.status || 'active'
                    });

                    if (prod.primary_image) {
                        setImagePreview(`https://rbuymart.rbhardwaj.com/server/${prod.primary_image}`);
                    }
                } else {
                    setError(data.message || "Failed to load product details.");
                }
            } catch (err) {
                setError("Network error. Could not retrieve product.");
            } finally {
                setLoading(false);
            }
        };

        fetchProductDetails();
    }, [id, token]);

   
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPrimaryImage(file);
            setImagePreview(URL.createObjectURL(file)); // लोकल प्रीव्यू बनाने के लिए
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const dataToSend = new FormData();
        dataToSend.append('id', id);
        dataToSend.append('name', formData.name);
        dataToSend.append('slug', formData.slug);
        dataToSend.append('sku', formData.sku);
        dataToSend.append('category_id', formData.category_id);
        dataToSend.append('brand_id', formData.brand_id);
        dataToSend.append('short_description', formData.short_description);
        dataToSend.append('description', formData.description);
        dataToSend.append('price', formData.price);
        dataToSend.append('compare_at_price', formData.compare_at_price);
        dataToSend.append('gst_percent', formData.gst_percent);
        dataToSend.append('stock', formData.stock);
        dataToSend.append('weight', formData.weight);
        dataToSend.append('status', formData.status);

        if (primaryImage) {
            dataToSend.append('primary_image', primaryImage);
        }

        try {
            const response = await fetch('https://rbuymart.rbhardwaj.com/server/api/admin/edit_product.php', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}` 
                },
                body: dataToSend 
            });

            const resData = await response.json();

            if (resData.status === 'success') {
                alert('Product updated successfully!');
                navigate('/admin/productlist');
            } else {
                alert(resData.message || 'Failed to update product.');
            }
        } catch (err) {
            alert('Network communication error while updating product.');
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) return <div className="admin-loader">Fetching Product Blueprint...</div>;
    if (error) return <div className="admin-error-banner">{error}</div>;

    return (
        <div className="edit-product-container">
            <div className="edit-header">
                <h2>Edit Product (ID: #{id})</h2>
                <button className="btn-back" onClick={() => navigate('/admin/productlist')}>
                 <i className="material-icons">&#xe5cb;</i> Back
                </button>
            </div>

            <form onSubmit={handleSubmit} className="edit-product-form">
                <div className="form-grid">
                    {/* Left Column - Core Info */}
                    <div className="form-column">
                        <div className="form-group">
                            <label>Product Name *</label>
                            <input 
                                type="text" 
                                name="name" 
                                value={formData.name} 
                                onChange={handleInputChange} 
                                required 
                            />
                        </div>

                        <div className="form-group-row">
                            <div className="form-group">
                                <label>Slug</label>
                                <input 
                                    type="text" 
                                    name="slug" 
                                    value={formData.slug} 
                                    onChange={handleInputChange} 
                                    placeholder="e.g. silver-jhumka-earrings" 
                                />
                            </div>
                            <div className="form-group">
                                <label>SKU (Stock Keeping Unit)</label>
                                <input 
                                    type="text" 
                                    name="sku" 
                                    value={formData.sku} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                        </div>

                        <div className="form-group-row">
                            <div className="form-group">
                                <label>Category ID</label>
                                <input 
                                    type="number" 
                                    name="category_id" 
                                    value={formData.category_id} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Brand ID</label>
                                <input 
                                    type="number" 
                                    name="brand_id" 
                                    value={formData.brand_id} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Short Description</label>
                            <textarea 
                                name="short_description" 
                                value={formData.short_description} 
                                onChange={handleInputChange} 
                                rows="2"
                            />
                        </div>

                        <div className="form-group">
                            <label>Long Description</label>
                            <textarea 
                                name="description" 
                                value={formData.description} 
                                onChange={handleInputChange} 
                                rows="5"
                            />
                        </div>
                    </div>

                 
                    <div className="form-column">
                        <div className="form-group-row">
                            <div className="form-group">
                                <label>Selling Price (₹) *</label>
                                <input 
                                    type="number" 
                                    step="0.01" 
                                    name="price" 
                                    value={formData.price} 
                                    onChange={handleInputChange} 
                                    required 
                                />
                            </div>
                            <div className="form-group">
                                <label>Compare At Price (₹)</label>
                                <input 
                                    type="number" 
                                    step="0.01" 
                                    name="compare_at_price" 
                                    value={formData.compare_at_price} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                        </div>

                        <div className="form-group-row">
                            <div className="form-group">
                                <label>Stock (Qty)</label>
                                <input 
                                    type="number" 
                                    name="stock" 
                                    value={formData.stock} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Weight (kg)</label>
                                <input 
                                    type="number" 
                                    step="0.01" 
                                    name="weight" 
                                    value={formData.weight} 
                                    onChange={handleInputChange} 
                                    placeholder="0.00" 
                                />
                            </div>
                        </div>

                        <div className="form-group-row">
                            <div className="form-group">
                                <label>GST Percent (%)</label>
                                <input 
                                    type="number" 
                                    name="gst_percent" 
                                    value={formData.gst_percent} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Status</label>
                                <select name="status" value={formData.status} onChange={handleInputChange}>
                                    <option value="active">Active</option>
                                    <option value="draft">Draft</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </div>

             
                        <div className="form-group">
                            <label>Product Image</label>
                            <input 
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageChange} 
                                className="file-input"
                            />
                            {imagePreview && (
                                <div className="image-preview-wrapper">
                                    <img src={imagePreview} alt="Preview" className="edit-img-preview" />
                                    <p className="preview-label">Current / New Selected Image</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button 
                        type="button" 
                        className="btn-cancel" 
                        onClick={() => navigate('/admin/productlist')}
                    >
                        Cancel
                    </button>
                    <button 
                        type="submit" 
                        className="btn-update" 
                        disabled={submitting}
                    >
                        {submitting ? 'Update...' : 'Update'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditProduct;